import React, { useEffect, useState } from "react";
import "./LeavingCertificate.css"; // Create a CSS file for styling
import { baseUrl, formatDateToDDMMYYYY } from "../../Utility/constants";
import axios from "axios";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const BonafideCertificateEnglishPreview = ({ currentCertificateNumber, studentId, onReasonChange }) => {
  const [schoolId, setSchoolId] = useState("");
  const [certificateData, setCertificateData] = useState([]);
  const [schoolData, setSchoolData] = useState([]);
  const [reasonMaster, setReasonMaster] = useState([]);
  const [reason, setReason] = useState('');

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [
          reasonRes
        ] = await Promise.all([
          axios.get(`${baseUrl}/api/BonafideReasonMaster`)
        ]);
        setReasonMaster(reasonRes.data)
      } catch (error) {
        console.log("Failed to fetch dropdown data");
      }
    };

    fetchDropdowns();
  }, []);

  useEffect(() => {
    const fetchCertificateData = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/PersonalDetails/ReturnStudentDetails?studentId=${studentId}`
        );
        if (response && response.data) {
          setCertificateData(response.data);
          if (response.data.schoolId) setSchoolId(response.data.schoolId);
        }
      } catch (error) {
        console.log(
          "Failed to fetch student details. Please try again.",
          error
        );
      }
    };
    fetchCertificateData();
  }, []);

  useEffect(() => {
    if (schoolId) {
      const fetchSchoolData = async () => {
        try {
          const response = await axios.get(
            `${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`
          );
          if (response && response.data) {
            setSchoolData(response.data);
          }
        } catch (error) {
          console.log(
            "Failed to fetch student details. Please try again.",
            error
          );
        }
      };
      fetchSchoolData();
    }
  }, [schoolId]);

  const handleReasonChange = (e) => {
    const selectedId = e.target.value;

    const selectedReason = reasonMaster.find(
      x => x.id.toString() === selectedId
    );

    setReason(selectedId);

    if (onReasonChange) {
      onReasonChange(selectedReason);
    }
  };

  return (
    <div className="certificate-container">
      <div>
        <table className="header-table">
          <tbody>
            <tr>
              <td style={{ width: "200px", verticalAlign: "middle", textAlign: "center" }}>
                <img src={schoolData.logo} className="responsive" width="150" />
              </td>
              <td style={{ borderRight: "none" }}>
                <b style={{ fontSize: "18px" }}>
                  {schoolData.organizationName}{" "}
                </b>
                <br />
                <b style={{ fontSize: "18px", fontWeight: "bold" }}>
                  {schoolData.schoolOrCollegeName}
                </b>
                <br />
                <b>(Affiliated to H.S.C. Board, Govt. Of Maharashtra)</b>
                <br />
                Address : {schoolData.address}
                <br />
                Phone No. <b>{schoolData.schoolOrCollegeContactNo}</b> | Website
                : <b>{schoolData.schoolWebsiteName}</b>
                <br></br>
                Email : <b>{schoolData.email}</b>
                <br />
                U-DISE No : <b>{schoolData.udiseNo} </b> |{" "}
                {(schoolData.ssC10thIndexNo || schoolData.hsC12thIndexNo) && (
                  <>
                    Index No :
                    <b>
                      {schoolData.ssC10thIndexNo}
                      {schoolData.ssC10thIndexNo &&
                        schoolData.hsC12thIndexNo &&
                        " | "}
                      {schoolData.hsC12thIndexNo}
                    </b>
                  </>
                )}
              </td>
              <td style={{ width: "200px", borderLeft: "none" }}></td>
            </tr>
          </tbody>
        </table>
        <table className="header-table">
          <tbody>
            <tr>
              {/* First Column - School Recognition No */}
              <td style={{ width: "50%" }}>
                School / College Recognition No.
                <b>
                  {" "}
                  :{" "}
                  {schoolData.schoolRegistrationNumber &&
                    schoolData.schoolRegistrationNumber}
                  {schoolData.schoolRegistrationNumber &&
                    schoolData.collegeRegistrationNumber &&
                    " | "}
                  {schoolData.collegeRegistrationNumber &&
                    schoolData.collegeRegistrationNumber}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <div className="certificate-title mb-3">
          <h5 className="title d-inline-block mx-2 mt-4">BONAFIDE CERTIFICATE</h5>
        </div>
        {/* Certificate No and Photo Row */}
        <div className="d-flex align-items-center justify-content-between mt-3 mb-3">
          {/* Passport Photo Placeholder */}
          <div
            className="border border-dark d-flex align-items-center justify-content-center"
            style={{ width: "51mm", height: "51mm", textAlign: "center" }}
          >
            <span className="text-muted">Passport Size Photo</span>
          </div>

          {/* Certificate Number */}
          <span className="d-block text-end"><b>Certificate No: {currentCertificateNumber}</b></span>
        </div>
        <div className="col-md-12" style={{ textAlign: "justify" }}>
          This is to certify that Kumar / Kumari {" "}
          <b>{certificateData.firstName + " " + certificateData.middleName + " " + certificateData.lastName} </b>is / was a
          bonafide student of this school / Junior college studying in {" "}
          <b>{certificateData.standardName} {certificateData.stream} {certificateData.section}</b> during the year <b>{certificateData.sessionName}</b>.
          <br></br><br></br>
          According to General Register of our school his / her date of birth is
          <b> {certificateData.dateOfBirth && formatDateToDDMMYYYY(certificateData.dateOfBirth.split("T")[0])}</b> and
          caste is <b>{certificateData.religion}-{certificateData.caste}</b> and place of birth is <b>{certificateData.birthPlace}</b>.
        </div>
        <div className="col-md-12 mt-4 mb-4" style={{ textAlign: "justify" }}>
          {/* To the best of my knowledge, He / She bears a good moral character. */}
          {certificateData.bonfileReason}
        </div>
        <div id="HeadmasterPrincipal"><span class="d-block text-end">Headmaster/Principal</span></div>
        <div id="HeadmasterPrincipal" style={{ width: "250px" }}><span class="d-block text-end">
          <Form.Group controlId="formGender">
            <Form.Control
              as="select"
              name="reasonMaster"
              value={reason || ""}
              onChange={handleReasonChange}
              required>
              <option value="">Select Reason</option>
              {reasonMaster.map((item, index) => (
                <option key={index} value={item.id}>{item.name}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </span></div>
      </div>
    </div>
  );
};

export default BonafideCertificateEnglishPreview;
